// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.build-expression {
  margin-left: 1%;
  margin-right: 1%;
}

.ap {
  width: 50%;
  height: 50%;
  border-radius: 5px;
  background-color: #17A0B4;
  color: white;
  margin-left: 1%;
  margin-right: 1%;
  border: none;
}

.app-expression-builder {
  width: 80%;
  height: 80%;
  box-sizing: border-box;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0px 10px 50px 20px darkgrey;
}

:host ::ng-deep {
  /* Match mapping notes modal size / layering so it appears above Rule Builder */
}
:host ::ng-deep .mat-mdc-raised-button.mat-primary {
  background-color: #17A0B4;
  color: white;
}
:host ::ng-deep .mat-mdc-raised-button:disabled {
  color: grey;
}
:host ::ng-deep .custom-dialog-container .mat-dialog-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
:host ::ng-deep .Predicate-dialog-container.mat-dialog-container {
  width: 67% !important;
  height: 66% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  max-height: 18vw !important;
  max-width: 18vw !important;
  overflow: auto;
}
:host ::ng-deep .matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  height: 24px !important;
}
:host ::ng-deep .matoutlinestyles.mappstatus .mat-mdc-form-field-infix {
  padding-bottom: 0px !important;
  min-height: 30px !important;
}
:host ::ng-deep .matoutlinestyles.mappstatus .mat-mdc-select {
  bottom: 5px !important;
  position: relative !important;
}
:host ::ng-deep .mappingnote .modal-dialog {
  max-width: 83% !important;
  top: 10% !important;
  max-height: 60% !important;
  height: 52% !important;
  margin: auto !important;
  padding: 0 !important;
}
:host ::ng-deep .mappingnote .modal-backdrop.show {
  z-index: 2000 !important;
}

.qc-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.qc-modal {
  width: 80%;
  max-width: 1000px;
  max-height: 85%;
  background: #fff;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.qc-audit-container {
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Version Notes overlay (read-only) */
.version-notes-modal {
  max-height: 75vh;
  display: flex;
  flex-direction: column;
}

.version-notes-header {
  border-bottom: 1px solid #dee2e6;
  padding: 12px 16px;
}

.version-notes-subtitle {
  font-weight: normal;
  color: #6c757d;
  font-size: 0.95em;
}

.version-notes-body {
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 120px;
}

.version-notes-loading,
.version-notes-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}

.version-notes-list {
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}

.version-note-card {
  border-left: 3px solid #17a2b8;
  padding: 8px 0;
}

.version-note-role {
  color: #17a2b8;
  font-size: 0.9em;
}

.version-note-text {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100px;
  border-left: 1px dashed #dee2e6;
  border-right: 1px dashed #dee2e6;
  padding-left: 10px;
}

.version-note-meta {
  font-size: 0.85em;
  color: #6c757d;
}

/* Compare overlay */
.compare-modal {
  max-width: 95vw;
  width: 95vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.compare-header {
  border-bottom: 1px solid #dee2e6;
  padding: 10px 16px;
  background: #f8f9fa;
}

.compare-subtitle {
  font-weight: normal;
  color: #0d6efd;
  font-size: 0.9em;
}

.compare-displayname {
  color: #0d6efd;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 600;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.15s, color 0.15s;
}

.compare-body {
  padding: 14px 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.compare-version-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0;
  margin-bottom: 12px;
}

.compare-version-field--left {
  justify-self: start;
  grid-column: 1;
}

.compare-version-field--right {
  justify-self: start;
  grid-column: 2;
}

.compare-version-field {
  flex: 0 1 auto;
  min-width: 160px;
  max-width: 280px;
  width: 100%;
  height: 44px;
}

/* Compact dropdowns: reduce height and padding so they don�t look oversized */
:host ::ng-deep .compare-version-field .mat-mdc-text-field-wrapper {
  padding-top: 0;
  padding-bottom: 0;
  height: 40px;
}
:host ::ng-deep .compare-version-field .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 40px;
}
:host ::ng-deep .compare-version-field .mat-mdc-floating-label,
:host ::ng-deep .compare-version-field mat-label {
  font-size: 13px;
}
:host ::ng-deep .compare-version-field .mat-mdc-select-value,
:host ::ng-deep .compare-version-field .mat-mdc-select-placeholder {
  font-size: 0.875rem;
}

.compare-diff-container {
  flex: 1;
  min-height: 400px;
}

.version-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.version-pill {
  background: #ffffff;
  border-radius: 20px;
  padding: 2px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.version-field {
  width: 240px;
}

/* Rule Builder header: title + compact Version dropdown only */
.rule-builder-header {
  min-height: auto;
  width: 100%;
  border-bottom: 1px solid #eceeef;
  font-size: 18px;
  font-weight: 600;
  padding: 6px 2% 6px 1%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rule-builder-title-row {
  flex: 1;
}

.rule-builder-version-field {
  width: 280px;
  max-width: 100%;
  margin-block: 0;
  top: -3px;
}

.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 24px !important;
}

.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-form-field-infix {
  padding-bottom: 0 !important;
  min-height: 30px !important;
}

.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-select {
  bottom: 5px !important;
  position: relative !important;
}

/* Version dropdown option styling (only latest item gets highlight colors) */
.rc-version-live {
  color: #2d862d;
  font-weight: 600;
  font-size: 12px;
}

.rc-version-devqc {
  color: #ff9900;
  font-weight: 600;
  font-size: 12px;
}

.rc-version-default {
  font-size: 12px;
}

/* ADDED: Version mat-select (Rule Builder header) — non-blocking backdrop + panel above dialog */
::ng-deep body.rule-builder-version-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.rule-builder-version-select-panel {
  z-index: 10001 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/rule-config-component.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAMI,eAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,uCAAA;AAJJ;;AAOA;EAiDM,+EAAA;AApDN;AAII;EACI,yBAAA;EACA,YAAA;AAFR;AAII;EACI,WAAA;AAFR;AAKI;EAGI,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,UAAA;AANR;AASM;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,2BAAA;EACA,0BAAA;EACA,cAAA;AAPR;AAYM;EACE,2BAAA;EACA,8BAAA;EACA,uBAAA;AAVR;AAaM;EACE,8BAAA;EACA,2BAAA;AAXR;AAcM;EACE,sBAAA;EACA,6BAAA;AAZR;AAgBM;EACE,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAdR;AAiBM;EACE,wBAAA;AAfR;;AAmBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;;AAmBA,sCAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,gCAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAhBF;;AAmBA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,8BAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,cAAA;AAhBF;;AAmBA,oBAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,MAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,mBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAhBF;;AAmBA,8EAAA;AAEE;EACE,cAAA;EACA,iBAAA;EACA,YAAA;AAjBJ;AAmBE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AAjBJ;AAmBE;;EAEE,eAAA;AAjBJ;AAmBE;;EAEE,mBAAA;AAjBJ;;AAqBA;EACE,OAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yCAAA;AAlBF;;AAqBA;EACE,YAAA;AAlBF;;AAqBA,+DAAA;AACA;EACE,gBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAlBF;;AAqBA;EACE,OAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,4BAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,4BAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,6BAAA;AAlBF;;AAqBA,6EAAA;AACA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,eAAA;AAlBF;;AAqBA,iGAAA;AACA;EAEE,+BAAA;AAnBF;;AAsBA;EACE,yBAAA;AAnBF","sourcesContent":[".build-expression {\r\n    // width: 100%;\r\n    // height: 100%;\r\n    // border-radius: 5px;\r\n    // background-color: #17A2B8;\r\n    // color: white;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n    // border: none;\r\n}\r\n\r\n.ap {\r\n    width: 50%;\r\n    height: 50%;\r\n    border-radius: 5px;\r\n    background-color: #17A0B4;\r\n    color: white;\r\n    margin-left: 1%;\r\n    margin-right: 1%;\r\n    border: none;\r\n}\r\n\r\n.app-expression-builder {\r\n    width: 80%;\r\n    height: 80%;\r\n    box-sizing: border-box;\r\n    border-radius: 10px 10px 10px 10px;\r\n    box-shadow: 0px 10px 50px 20px darkgrey;\r\n}\r\n\r\n:host ::ng-deep {\r\n    .mat-mdc-raised-button.mat-primary {\r\n        background-color: #17A0B4;\r\n        color: white;\r\n    }\r\n    .mat-mdc-raised-button:disabled{\r\n        color: grey;\r\n    }\r\n\r\n    .custom-dialog-container .mat-dialog-container {\r\n        //width: 67% !important;\r\n        //height: 43% !important;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        //background: white; // Adjust as needed\r\n        padding: 0; // Remove default padding\r\n      }\r\n\r\n      .Predicate-dialog-container.mat-dialog-container {\r\n        width: 67% !important;\r\n        height: 66% !important;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;   \r\n        padding: 0; \r\n        max-height: 18vw !important;  \r\n        max-width: 18vw !important;\r\n        overflow: auto; \r\n      }\r\n    \r\n\r\n      //RuleVersion changes\r\n      .matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper{\r\n        padding-top: 0px !important;\r\n        padding-bottom: 0px !important;\r\n        height: 24px !important;\r\n      }\r\n\r\n      .matoutlinestyles.mappstatus .mat-mdc-form-field-infix{\r\n        padding-bottom: 0px !important;\r\n        min-height: 30px !important;\r\n      }\r\n\r\n      .matoutlinestyles.mappstatus .mat-mdc-select{\r\n        bottom: 5px !important;\r\n        position:relative !important;\r\n      }\r\n\r\n      /* Match mapping notes modal size / layering so it appears above Rule Builder */\r\n      .mappingnote .modal-dialog {\r\n        max-width: 83% !important;\r\n        top: 10% !important;\r\n        max-height: 60% !important;\r\n        height: 52% !important;\r\n        margin: auto !important;\r\n        padding: 0 !important;\r\n      }\r\n\r\n      .mappingnote .modal-backdrop.show {\r\n        z-index: 2000 !important;\r\n      }\r\n}\r\n\r\n.qc-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10;\r\n}\r\n\r\n.qc-modal {\r\n  width: 80%;\r\n  max-width: 1000px;\r\n  max-height: 85%;\r\n  background: #fff;\r\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.qc-audit-container {\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* Version Notes overlay (read-only) */\r\n.version-notes-modal {\r\n  max-height: 75vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.version-notes-header {\r\n  border-bottom: 1px solid #dee2e6;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.version-notes-subtitle {\r\n  font-weight: normal;\r\n  color: #6c757d;\r\n  font-size: 0.95em;\r\n}\r\n\r\n.version-notes-body {\r\n  padding: 16px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 120px;\r\n}\r\n\r\n.version-notes-loading,\r\n.version-notes-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 32px 16px;\r\n}\r\n\r\n.version-notes-list {\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.version-note-card {\r\n  border-left: 3px solid #17a2b8;\r\n  padding: 8px 0;\r\n}\r\n\r\n.version-note-role {\r\n  color: #17a2b8;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.version-note-text {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  max-height: 100px;\r\n  border-left: 1px dashed #dee2e6;\r\n  border-right: 1px dashed #dee2e6;\r\n  padding-left: 10px;\r\n}\r\n\r\n.version-note-meta {\r\n  font-size: 0.85em;\r\n  color: #6c757d;\r\n}\r\n\r\n/* Compare overlay */\r\n.compare-modal {\r\n  max-width: 95vw;\r\n  width: 95vw;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.compare-header {\r\n  border-bottom: 1px solid #dee2e6;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.compare-subtitle {\r\n  font-weight: normal;\r\n  color: #0d6efd;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.compare-displayname {\r\n  color: #0d6efd;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  font-weight: 600;\r\n  padding: 2px 4px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.15s, color 0.15s;\r\n}\r\n\r\n.compare-body {\r\n  padding: 14px 16px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n.compare-version-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  align-items: center;\r\n  gap: 0;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.compare-version-field--left {\r\n  justify-self: start;\r\n  grid-column: 1;\r\n}\r\n\r\n.compare-version-field--right {\r\n  justify-self: start;\r\n  grid-column: 2;\r\n}\r\n\r\n.compare-version-field {\r\n  flex: 0 1 auto;\r\n  min-width: 160px;\r\n  max-width: 280px;\r\n  width: 100%;\r\n  height: 44px;\r\n}\r\n\r\n/* Compact dropdowns: reduce height and padding so they don�t look oversized */\r\n:host ::ng-deep .compare-version-field {\r\n  .mat-mdc-text-field-wrapper {\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    height: 40px;\r\n  }\r\n  .mat-mdc-form-field-infix {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    min-height: 40px;\r\n  }\r\n  .mat-mdc-floating-label,\r\n  mat-label {\r\n    font-size: 13px;\r\n  }\r\n  .mat-mdc-select-value,\r\n  .mat-mdc-select-placeholder {\r\n    font-size: 0.875rem;\r\n  }\r\n}\r\n\r\n.compare-diff-container {\r\n  flex: 1;\r\n  min-height: 400px;\r\n}\r\n\r\n.version-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.version-pill {\r\n  background: #ffffff;\r\n  border-radius: 20px;\r\n  padding: 2px 12px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.version-field {\r\n  width: 240px;\r\n}\r\n\r\n/* Rule Builder header: title + compact Version dropdown only */\r\n.rule-builder-header {\r\n  min-height: auto;\r\n  width: 100%;\r\n  border-bottom: 1px solid #eceeef;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  padding: 6px 2% 6px 1%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.rule-builder-title-row {\r\n  flex: 1;\r\n}\r\n\r\n.rule-builder-version-field {\r\n  width: 280px;\r\n  max-width: 100%;\r\n  margin-block: 0;\r\n  top: -3px;\r\n}\r\n\r\n.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-text-field-wrapper {\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  height: 24px !important;\r\n}\r\n\r\n.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-form-field-infix {\r\n  padding-bottom: 0 !important;\r\n  min-height: 30px !important;\r\n}\r\n\r\n.rule-builder-header .matoutlinestyles.mappstatus .mat-mdc-select {\r\n  bottom: 5px !important;\r\n  position: relative !important;\r\n}\r\n\r\n/* Version dropdown option styling (only latest item gets highlight colors) */\r\n.rc-version-live {\r\n  color: #2d862d;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-version-devqc {\r\n  color: #ff9900;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-version-default {\r\n  font-size: 12px;\r\n}\r\n\r\n/* ADDED: Version mat-select (Rule Builder header) — non-blocking backdrop + panel above dialog */\r\n::ng-deep body.rule-builder-version-select-open\r\n  .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n  pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.rule-builder-version-select-panel {\r\n  z-index: 10001 !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
